/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAssignments.defs.js'
export { main as default } from './getAssignments.defs.js'
